import { render, staticRenderFns } from "./ShadowCustoms.vue?vue&type=template&id=cd982d8a"
import script from "./ShadowCustoms.vue?vue&type=script&lang=js"
export * from "./ShadowCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports